/**
 * True when a `messageDateMs` string is a real epoch we can hand to date-fns, which throws
 * `RangeError` on an invalid date. Checking the constructed `Date` rather than just the number
 * also rejects values past the ±8.64e15 range JS `Date` supports — those are finite and positive
 * but still produce an Invalid Date.
 */
export default function isDisplayableTimestamp(messageDateMs: string): boolean {
  const timestamp = Number(messageDateMs);
  return timestamp > 0 && !Number.isNaN(new Date(timestamp).getTime());
}
